import React from 'react';
import { Tooltip as AntdTooltip, Flex } from 'antd';

const Tooltip = (props) => {
  const { title, children, overlayStyle, widthAuto, minWidth, show = true, color, placement, ...rest } = props;

  if (!show) return <>{children}</>;

  return (
    <AntdTooltip
      title={title}
      color={color ? color : '#222222'}
      overlayStyle={overlayStyle}
      {...rest}
      placement={placement}
    >
      <Flex style={title ? { cursor: 'pointer' } : {}}> {children} </Flex>
    </AntdTooltip>
  );
};

export default Tooltip;
